import React from "react";
import { DiscountCardProps } from "./DiscountCard.types";
import {
	CardWrapper,
	IconList,
	IconWrapper,
	PercentageBadge,
	TextList,
} from "./DiscountCard.styles";
import { RangoCard, RangoParagraph } from "@rango/core";
import { MapTo } from "@adobe/aem-react-editable-components";

export default function DiscountCard({
	cardBackground,
	listLogos,
	listText,
	optionalText,
	id,
}: DiscountCardProps) {
	return (
		<>
			<CardWrapper id={id} style={{}}>
				{listLogos && (
					<IconList
						itemCount={listLogos.length}
						style={{
							justifyContent:
								listLogos.length === 1 ? "center" : "space-between",
						}}
					>
						{listLogos &&
							listLogos.map((logo, index) => (
								<IconWrapper
									key={index}
									style={{
										backgroundColor: cardBackground || "rgba(245, 245, 245, 1)",
									}}
								>
									<img src={logo.image} alt={logo.alt} loading="lazy" />
								</IconWrapper>
							))}
					</IconList>
				)}

				<RangoCard
					style={{
						backgroundColor: cardBackground || "rgba(245, 245, 245, 1)",
					}}
				>
					<TextList>
						{listText &&
							listText.map((item, index) => (
								<div key={index} className="text-item">
									<PercentageBadge>
										<RangoParagraph
											style={{ fontSize: "14px", color: "rgba(25, 25, 25, 1)" }}
										>
											{item.text}
										</RangoParagraph>
									</PercentageBadge>
									<div>
										<RangoParagraph
											style={{
												color: "rgba(25, 25, 25, 1)",
											}}
											size="sm"
										>
											{item.description}
										</RangoParagraph>
									</div>
								</div>
							))}
						<RangoParagraph
							style={{ fontSize: "14px", color: "rgba(25, 25, 25, 1)" }}
						>
							{optionalText}
						</RangoParagraph>
					</TextList>
				</RangoCard>
			</CardWrapper>
		</>
	);
}

const DiscountCardConfig = {
	emptyLabel: "Card de Desconto",

	isEmpty: function (props: DiscountCardProps) {
		return !props;
	},
};

MapTo<DiscountCardProps>("alelo/components/content/v1/discount-card")(
	DiscountCard,
	DiscountCardConfig
);
